<mb-expandable-panel #contentTaxes [expanded]="isExpanded">
  @if (breakdown !== undefined) {
    <div class="container-taxes">
      <div class="header-taxes">
        <button class="hidden-expan" (click)="hiddenPane()">
          <mb-icon-text>
            <span>Ver menos <mb-icon icon="arrow-up"></mb-icon></span>
          </mb-icon-text>
        </button>
      </div>
      @if (rate) {
        <div class="taxe bold">
          <p class="name-taxe">
            @if (fop === 'PAY_AT_DESTINATION') {
              <strong> Valor en dólares</strong>
            } @else {
              <strong>{{ rate.key }}</strong>
            }
          </p>
          <p class="value-taxe">
            <strong>{{ currencySymbol }}
            {{ rate.value | Currency }}</strong>
          </p>
        </div>
      }
      <ul>
        @if (fop === 'PAY_AT_DESTINATION') {
          <li>
            <div class="taxe">
              <p class="name-taxe">El precio en pesos argentinos es estimativo</p>
            </div>
          </li>
        }
        @for (charge of charges; track charge) {
          <li>
            <div class="taxe">
              <p class="name-taxe">{{ charge.key }}</p>
              <p class="value-taxe">{{ currencySymbol }} {{ charge.value | Currency }}</p>
            </div>
          </li>
        }
      </ul>
      @if (information) {
        <div class="disclaimer">
          <mb-icon icon="exclamation-circle" class="icon-focus"></mb-icon>
          <p class="disclaimer__text not-pad">@if (information?.title) {<strong>{{ information?.title }}.</strong>} {{ information?.information[0] }}</p>
        </div>
      }
    </div>
  }
</mb-expandable-panel>